module.exports = __webpack_public_path__ + "img/share_care_lt.b8e48d81.png";